var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("breadcrumb", {
        staticClass: "breadcrumb-container",
        attrs: { id: "breadcrumb-container" },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _vm.device !== "mobile"
            ? [_c("div", { staticClass: "helpcenter" })]
            : _vm._e(),
          _vm._v(" "),
          _c("LangSelect"),
          _vm._v(" "),
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container right-menu-item hover-effect",
              attrs: { trigger: "click" },
            },
            [
              _c(
                "div",
                { staticClass: "avatar-wrapper" },
                [
                  _c("svg-icon", { attrs: { "icon-class": "yonghu" } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "orgName" }, [
                    _vm._v(_vm._s(_vm.orgGroupName)),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-dropdown-menu", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (dropdown) {
                      return [
                        _c(
                          "router-link",
                          { attrs: { to: "/" } },
                          [
                            _c("el-dropdown-item", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("navbar.dashboard")) +
                                  "\n          "
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          { attrs: { to: "/userCenter/changePassword" } },
                          [
                            _c("el-dropdown-item", [
                              _vm._v(
                                "\n             " +
                                  _vm._s(_vm.$t("navbar.changePassword")) +
                                  "\n          "
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-dropdown-item", { attrs: { divided: "" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: { display: "block" },
                              on: { click: _vm.logout },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("navbar.logOut")) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }